import "./style.scss";

import BasicTable from "components/shared/BasicTable";
import type { BasicTableColumn } from "components/shared/BasicTable";
import TitleCover from "components/shared/TitleCover";
import type { IWorkTitleSummary } from "containers/Works/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type CoveredTitlesRecapProps = {
    titles?: IWorkTitleSummary[];
};

const CoveredTitlesRecap = ({ titles = [] }: CoveredTitlesRecapProps) => {
    const [t] = useTranslation();

    const columns = useMemo<BasicTableColumn<IWorkTitleSummary>[]>(
        () => [
            {
                header: t("ConnectTitle.CoveredTitles"),
                cellClassName: "covered-titles-recap-name",
                render: (row) => {
                    const meta = [row.ean13, row.formatTypeName?.trim()].filter(Boolean).join(" · ");
                    return (
                        <>
                            {row.id > 0 ? (
                                <TitleCover
                                    coverUrl={row.avatarUrl ?? undefined}
                                    title={row.name}
                                    color="title-color"
                                />
                            ) : null}
                            <span className="covered-titles-recap-copy">
                                <span className="covered-titles-recap-title" title={row.name}>
                                    {row.name}
                                </span>
                                {meta ? <span className="covered-titles-recap-isbn">{meta}</span> : null}
                            </span>
                        </>
                    );
                },
            },
        ],
        [t],
    );

    if (!titles.length) return null;

    return (
        <BasicTable<IWorkTitleSummary>
            columns={columns}
            rows={titles}
            className="covered-titles-recap"
            maxRows={3}
            showAllLabel={t("BalanceUpdate.BalanceTable.ShowAll")}
            hideLabel={t("BalanceUpdate.BalanceTable.Hide")}
        />
    );
};

export default CoveredTitlesRecap;
